module.exports = __webpack_public_path__ + "img/countersquaresm.9ae7dc83.webp";